import { GetContractorsResponse } from './collections/contractor/getListOfContractors/getListOfContractors_200'
import { handleNetworkResponseAndGetJsonAsync, handleNetworkResponseWithNoPayloadAsync, Network } from './Network'
import { GetContractorResponse } from './collections/contractor/getContractorDetail/getContractorDetail_200'
import { GlobalVars } from '../../global'
import { UpdateContractorRequest } from './collections/contractor/updateContractor/updateContractor_post'
import { UpdateContractorResponse } from './collections/contractor/updateContractor/updateContractor_200'
import { CreateContractorResponse } from './collections/contractor/createContractor/createContractor_200'
import { CreateContractorRequest } from './collections/contractor/createContractor/createContractor_post'
import { GetContractorEventsResponse } from './collections/contractor/getEventsOfContractor/getEventsOfContractor_200'
import { DatabaseLookupResponse } from './sharedTypes/Common'

export class ContractorManager {
    static _instance: ContractorManager | null = null

    static getManager(): ContractorManager {
        if (this._instance === null) {
            this._instance = new ContractorManager()
        }
        return this._instance
    }

    async createContractorAsync(contractor: CreateContractorRequest): Promise<CreateContractorResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/contractor/create`
        const body: CreateContractorRequest = contractor
        try {
            response = await Network.fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: CreateContractorResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async getContractorListAsync(): Promise<GetContractorsResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/contractor`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: GetContractorsResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async getAllFilteredContractorsAsync(dateFrom: string, dateTo: string): Promise<GetContractorsResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/contractor?EventsFrom=${dateFrom}&EventsTo=${dateTo}`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: GetContractorsResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async getEventsOfContractor(id: string): Promise<GetContractorEventsResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/contractor/${id}/event`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: GetContractorEventsResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async getContractorAsync(id: string): Promise<GetContractorResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/contractor/${id}`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: GetContractorResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async deleteContractorAsync(id: string): Promise<void> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/contractor/${id}`
        try {
            response = await Network.fetch(url, {
                method: 'DELETE',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: void = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async updateContractorAsync(id: string, contractor: UpdateContractorRequest): Promise<UpdateContractorResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/contractor/update/${id}`
        const body: UpdateContractorRequest = contractor
        try {
            response = await Network.fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: UpdateContractorResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async payContractorAsync(contractorId: string, eventId: string): Promise<void> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/event/${eventId}/contractor/${contractorId}/pay`
        try {
            response = await Network.fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            await handleNetworkResponseWithNoPayloadAsync(response)
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async getCarriersLookupAsync(): Promise<DatabaseLookupResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/contractor/lookup/carrier?canBeAssigned`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: DatabaseLookupResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async getBrigadiersLookupAsync(): Promise<DatabaseLookupResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/contractor/lookup/brigadier?canBeAssigned`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: DatabaseLookupResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }
}
